import type { DialogStatusMapping } from './dialog.types'

/** Defines icon visuals for each Dialog status. */
export const dialogStatusMapping: DialogStatusMapping = {
  danger: {
    iconProps: {
      color: 'red.80',
      name: 'falExclamationTriangle',
    },
  },
  error: {
    iconProps: {
      color: 'red.80',
      name: 'falTimesCircle',
    },
  },
  info: {
    iconProps: {
      color: 'blue.80',
      name: 'falInfoCircle',
    },
  },
  warning: {
    iconProps: {
      color: 'yellow.90',
      name: 'falExclamationTriangle',
    },
  },
}

export const modalAnimation = {
  left: 'fadeRightLong',
  center: 'fadeDown',
  right: 'fadeLeftLong',
}

export const modalJustifyContent = {
  left: 'start',
  center: 'center',
  right: 'end',
}

export const containerId = 'vui-dynamic-container'

export const modalClass = 'vui-modal'
